import React from 'react';

function FallbackImage() {
    return <img src="/images/poi-card-fallback-image.jpg" alt="" className="w-full h-full object-cover" />;
}

export default FallbackImage;
